import * as React from "react";

export const LogoTextmark: React.ElementType<React.SVGAttributes<
  SVGSVGElement
>> = (props: React.SVGAttributes<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 5777.97 1010.95" {...props}>
      <defs>
        <linearGradient
          id="prefix__linear-gradient"
          x1={-264.95}
          y1={682.2}
          x2={555.91}
          y2={682.2}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.27} stopColor="#f1f2f2" />
          <stop offset={0.35} stopColor="#edf0f2" />
          <stop offset={0.42} stopColor="#e1eaf2" />
          <stop offset={0.5} stopColor="#cee0f3" />
          <stop offset={0.57} stopColor="#b2d2f4" />
          <stop offset={0.65} stopColor="#8ec0f5" />
          <stop offset={0.72} stopColor="#64abf6" />
          <stop offset={0.78} stopColor="#3e98f7" />
        </linearGradient>
        <linearGradient
          id="prefix__linear-gradient-2"
          x1={625.8}
          y1={231.4}
          x2={600.76}
          y2={89.4}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.3} stopColor="#f1f2f2" />
          <stop offset={0.38} stopColor="#eaeef2" />
          <stop offset={0.49} stopColor="#d6e4f3" />
          <stop offset={0.63} stopColor="#b5d4f4" />
          <stop offset={0.79} stopColor="#87bdf5" />
          <stop offset={0.96} stopColor="#4da0f7" />
          <stop offset={1} stopColor="#3e98f7" />
        </linearGradient>
        <linearGradient
          id="prefix__Naamloos_verloop_12"
          x1={717.95}
          y1={311.14}
          x2={253.9}
          y2={311.14}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#f1f2f2" />
          <stop offset={1} stopColor="#3e98f7" />
        </linearGradient>
        <linearGradient
          id="prefix__linear-gradient-3"
          x1={928.39}
          y1={451.5}
          x2={811.15}
          y2={654.58}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#f1f2f2" />
          <stop offset={0.14} stopColor="#edf0f2" />
          <stop offset={0.29} stopColor="#dfe9f2" />
          <stop offset={0.44} stopColor="#c9def3" />
          <stop offset={0.6} stopColor="#aacff4" />
          <stop offset={0.77} stopColor="#83bbf5" />
          <stop offset={0.93} stopColor="#53a3f6" />
          <stop offset={1} stopColor="#3e98f7" />
        </linearGradient>
        <linearGradient
          id="prefix__linear-gradient-4"
          x1={703.1}
          y1={267.78}
          x2={-4.01}
          y2={974.89}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.11} stopColor="#f1f2f2" />
          <stop offset={0.21} stopColor="#e8eef2" />
          <stop offset={0.36} stopColor="#d1e2f3" />
          <stop offset={0.56} stopColor="#aacef4" />
          <stop offset={0.79} stopColor="#75b4f5" />
          <stop offset={1} stopColor="#3e98f7" />
        </linearGradient>
        <linearGradient
          id="prefix__Naamloos_verloop_12-2"
          x1={679.01}
          y1={631.99}
          x2={848.38}
          y2={631.99}
          xlinkHref="#prefix__Naamloos_verloop_12"
        />
        <linearGradient
          id="prefix__Naamloos_verloop_26"
          x1={943.3}
          y1={252.69}
          x2={67.65}
          y2={758.25}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#808285" />
          <stop offset={0.55} stopColor="#4d4c4e" />
          <stop offset={1} stopColor="#231f20" />
        </linearGradient>
        <linearGradient
          id="prefix__Naamloos_verloop_12-3"
          x1={159.16}
          y1={244.29}
          x2={579.5}
          y2={244.29}
          xlinkHref="#prefix__Naamloos_verloop_12"
        />
        <style>
          {
            ".prefix__cls-2{fill:none}.prefix__cls-3{fill:#f1f2f2}.prefix__cls-9{fill:#fff}"
          }
        </style>
      </defs>
      <g
        style={{
          isolation: "isolate",
        }}
      >
        <g id="prefix__Layer_2" data-name="Layer 2">
          <g id="prefix__Laag_2" data-name="Laag 2">
            <path
              className="prefix__cls-2"
              d="M4488.72 407c0-25-19.05-43-46.84-43h-132.57v86.84h132.57c27.79 0 46.84-17.99 46.84-43.84zm-42.08 158.06h-137.33v93.88h137.33c32.55 0 52.4-18.78 52.4-46.94-.04-25.82-19.04-46.94-52.4-46.94z"
            />
            <ellipse
              className="prefix__cls-2"
              cx={2050.18}
              cy={505.63}
              rx={153.95}
              ry={146.89}
            />
            <path
              className="prefix__cls-2"
              d="M3722.44 575.67h142.31l-71.15-200.93-71.16 200.93z"
            />
            <ellipse
              className="prefix__cls-2"
              cx={4991.64}
              cy={505.63}
              rx={153.95}
              ry={146.89}
            />
            <path
              className="prefix__cls-3"
              d="M1307.86 238.65V772.6h143.99V562.06h173.21l64-120.07h-237.21v-83.26h281.59l64-120.08h-489.58zm2395.33 0l-210.12 534h163.24l27.62-76.85h220.17l27.63 76.85H4095l-211-534zm19.25 337l71.16-200.93 71.15 200.93zm-1672.26-337c-154.53 0-279.79 119.53-279.79 267s125.26 267 279.79 267 279.8-119.53 279.8-267-125.27-267-279.8-267zm0 413.87c-85 0-153.95-65.77-153.95-146.89s68.93-146.9 153.95-146.9 154 65.77 154 146.9-68.97 146.89-154 146.89z"
            />
            <path
              d="M4991.64 238.65c-154.53 0-279.79 119.53-279.79 267s125.26 267 279.79 267 279.8-119.53 279.8-267-125.27-267-279.8-267zm0 413.87c-85 0-154-65.77-154-146.89s68.93-146.9 154-146.9 153.95 65.77 153.95 146.9-68.92 146.89-153.95 146.89zm-454.5-149.26c50-11 90.5-54.77 90.5-119.7 0-65.71-50-133-154.8-133h-300.07v521.8h309.6c104 0 155.59-65.71 155.59-141.6.04-65.7-44.45-118.9-100.82-127.5zM4309.31 364h132.57c27.79 0 46.84 18 46.84 43 0 25.82-19.05 43.81-46.84 43.81h-132.57zm137.33 294.94h-137.33v-93.88h137.33c33.35 0 52.4 21.12 52.4 46.94-.04 28.16-19.85 46.94-52.4 46.94zm898.68-408.37v117.34h148.45v404.46h136.54V367.91h147.66V250.57h-432.65z"
              fill="#3e8eed"
            />
            <path
              className="prefix__cls-3"
              d="M2449.85 287.58q-47.88 49.25-47.87 118 0 50 25.35 89.7s1 1.75 3.1 4.7v.06l1.08 1.5c.92 1.31 1.84 2.62 2.8 3.91h.16c15.21 19.41 54.84 59.85 121.14 60.1 3.55.2 7.14.32 10.79.32h164.45q14.63 0 25.58 11.27c7.31 7.52 11 21.09 11 32.36s-3.65 22.34-11 29.85-15.83 11.28-25.58 11.28h-264.72L2402 772.6h328.9q68.7 0 116.58-49.24t47.87-118q0-49.2-24.51-88.39s-1.14-2-3.42-5.23c-1.43-2.1-2.9-4.19-4.44-6.26h-.22c-15.85-20.15-55.29-59.81-120.36-60.06h-.11c-3.75-.24-7.54-.36-11.39-.36h-164.47q-14.62 0-25.58-11.28c-7.31-7.51-11-21.08-11-32.36s3.66-22.33 11-29.85 15.83-11.27 25.58-11.27h261l67.94-122h-328.9q-68.75.05-116.62 49.28zm567.23 0q-47.88 49.25-47.87 118 0 50 25.35 89.7s1 1.75 3.11 4.7a.21.21 0 000 .06q.5.7 1.08 1.5c.92 1.31 1.83 2.62 2.8 3.91h.15c15.22 19.41 54.84 59.85 121.14 60.1 3.56.2 7.15.32 10.79.32h164.45q14.63 0 25.58 11.27c7.31 7.52 11 21.09 11 32.36s-3.66 22.34-11 29.85-15.83 11.28-25.58 11.28h-264.72l-64.15 122h328.9q68.71 0 116.58-49.24t47.87-118q0-49.2-24.51-88.39s-1.14-2-3.42-5.23c-1.43-2.1-2.9-4.19-4.44-6.26h-.19c-15.86-20.15-55.3-59.81-120.36-60.06h-.11q-5.62-.36-11.4-.36h-164.47q-14.62 0-25.58-11.28c-7.31-7.51-11-21.08-11-32.36s3.65-22.33 11-29.85 15.83-11.27 25.58-11.27h261l67.94-122h-328.9q-68.7.02-116.62 49.25z"
            />
            <circle
              cx={505.47}
              cy={505.47}
              r={505.47}
              fill="#3e98f7"
            />
            <path
              d="M352.66 400.76s-133.4-55.4-189.25 3.64 10 317 157 402.09 337.25 180.74 337.25 180.74-85.88-330.69-40.31-466-264.69-120.47-264.69-120.47z"
              fill="url(#prefix__linear-gradient)"
            />
            <path
              d="M645.29 172.85s-38.24-15.34-63.24-20.44c4-6.25 8.07-12.82 11.54-18.47l-.37-.17s25.11 8.45 52.07 39.08z"
              fill="url(#prefix__linear-gradient-2)"
            />
            <path
              d="M502.46 269.13s41.6-13.27 90.44-6.66c91.35 19.37 95.27 99.18 95.27 99.18-45.95-93.72-165.4-68-165.4-68z"
              fill="url(#prefix__Naamloos_verloop_12)"
            />
            <path
              className="prefix__cls-9"
              d="M214.18 416.24s2.11 67.69 19.88 85.65c0 0 19-40.11 86.37-67.68 0 0-49.44 135.36-12.47 235.53 0 0-54.91-32.31-41.94-164.39 0 0-25.82 31.73-31.34 69.12 0 0-53.43-74.18-20.5-158.23z"
            />
            <path
              d="M918.82 453.82c1-.27-1 .24 0 0 10.18 71.39-27 91-38.69 95.37C860.18 492.9 907 461 918.82 453.82z"
              fill="url(#prefix__linear-gradient-3)"
            />
            <path
              className="prefix__cls-9"
              d="M657.65 987.23zm-84.9-58.46a201.14 201.14 0 01-14.1-20.83 174.87 174.87 0 01-11.94-24 1.62 1.62 0 00-.06-.17v-.15a123.4 123.4 0 01-5-16.34c.88.4 1.74.77 2.6 1.14 7.4 3 30.3 10.82 65 8.55q-3-2.51-5.85-5c-34.88-31.31-46.8-64.71-47.08-95.46-.28-31.66 11.79-60.52 23.86-81.39a201.65 201.65 0 0123.82-33.5c-94.5 66.51-62.42 174.49-62.42 174.49a216.11 216.11 0 01-45.18-15.92c20.58 146.3 120.81 165.06 159.26 167l2 .07s-47.22-8.13-84.91-58.49z"
            />
            <path
              d="M788.56 408c6-4.69 10.73-4.89 13.32-4.66s10.47 2.87 22 5.72c43 10.64 72.6-5.72 72.6-5.72-14.29-20.11-39.53-42.45-62.07-60.33-9.94-7.89-19.35-14.91-27.07-20.5-10.47-8.32-3.4-27.25-3.4-27.25a380.36 380.36 0 00-131.56-110.32 143.88 143.88 0 00-11.64-45.84c-7.45-17.19-16.64-29.69-22.19-33.51-5.36-3.68-12.36-6.08-17.61-7.5a8.86 8.86 0 00-10.33 4.73c-2.6 5.49-5.75 11.3-8.65 16.39-4.7 8.23-8.74 14.56-8.74 14.56s25.11 8.45 52.07 39.08c0 0-38.24-15.34-63.24-20.44a392.91 392.91 0 00-198.5 7.08 77.36 77.36 0 0014.25 28.79c-11.09-3.2-25.21-9-40.69-16.21q-2-.95-4.11-1.94c-57.51-27.3-131.36-72.25-139.7-77.36a530 530 0 00-47.68 38.48c2.71 12 15.93 67.28 30 97.57 0 0 13.92-30.05 36.15-49.55-30.06 89.2-25.78 178-25.78 178v.06a319.66 319.66 0 01-50.92-8.33 340 340 0 01-43.39-13.77c-3-1.18-4.58-1.9-4.58-1.9A379.81 379.81 0 006 430.82a509.67 509.67 0 00-5.4 74.07c0 279.17 226.31 505.47 505.47 505.47a505.22 505.22 0 00151.61-23.13l-2-.07c-38.45-1.91-138.68-20.67-159.26-167a216.11 216.11 0 0045.18 15.92s-32.08-108 62.42-174.49-139.5 33.09-216.43 147.86c9.82-86.07 71-154.66 71-154.66C358.47 675 307 735.65 307 735.65c-50.54-25.66-76.57-99.07-76.57-99.07-96.66-85.22-22.9-209.64-16.27-220.34 0 0 2.11 67.69 19.88 85.65 0 0 19-40.11 86.37-67.68 0 0-49.44 135.36-12.47 235.53 0 0 85.05-75.81 292.44-101v-2.16a86.48 86.48 0 011.14-11.58c.2-1.21.43-2.39.67-3.56.43-2.08 1-4.07 1.53-6a.22.22 0 000-.08 42.32 42.32 0 014.38-10.89 59.79 59.79 0 019.24-13.28c11.21-13 29.17-25.52 53.71-25.18 41.88.58 68.64-6.95 68.64-6.95-16.17 22.76-54.6 29.39-54.6 29.39 19 15.19 58.81 7.84 58.81 7.84-15.93 22.05-50.84 31.06-50.84 31.06 33.86 6.37 60 3.48 80-3.81l.22-.08a101.13 101.13 0 0019.33-9.5c23.62-13.08 35.47-37 41.25-54.74a47.5 47.5 0 002.14-21.04 48.48 48.48 0 00-1.09-5.56c-1.51-5.41-5.91-16.12-17.44-17.79a29.81 29.81 0 00-3.16-.18 27.06 27.06 0 00-13.17 3.35s-20.08-11.44-26.28-17.25 0-13.19 0-13.19 7.76-4.91 13.7-9.56zm-573.33 5.7l.05-.15zM600.4 568.73zm87.77-207.08s-87 38.59-165.4-68l-20.31-24.53s41.6-13.27 90.44-6.66c91.35 19.37 95.27 99.18 95.27 99.18z"
              fill="url(#prefix__linear-gradient-4)"
            />
            <path
              className="prefix__cls-9"
              d="M848.29 604.12c-.05-1.11-.15-2.26-.29-3.42v-.05a42.69 42.69 0 00-6.26-17.37 21.79 21.79 0 00-27.57-9.74l-25 10.41-1.55.65c-9.73 4-63.47 24.09-103.74 5.44q-2.49-1.16-4.91-2.5c31.7 75.18 89.78 65 113.87 56.81q5.13-1.87 10.91-4.46a10.17 10.17 0 01-1.45 2.36c-12.42 19.51-34.14 34.09-34.14 34.09a118.94 118.94 0 0017.27-2.86c36.13-8.84 51.78-31.5 58.5-46.76a45 45 0 004.36-22.6z"
            />
            <path
              d="M848 600.68c-7.58-5.93-18.82-10.4-37.07-2.69-97.57 41.19-131.39-9.49-132-10.41 31.7 75.18 89.78 65 113.87 56.81q5.13-1.87 10.91-4.46a10.17 10.17 0 01-1.45 2.36c-12.42 19.51-34.14 34.09-34.14 34.09a118.94 118.94 0 0017.27-2.86c36.13-8.84 51.78-31.5 58.5-46.76 3.23-7.15 5.36-13.94 4.11-26.08z"
              opacity={0.35}
              fill="url(#prefix__Naamloos_verloop_12-2)"
            />
            <circle
              cx={505.47}
              cy={505.47}
              r={505.47}
              style={{
                mixBlendMode: "overlay",
              }}
              fill="url(#prefix__Naamloos_verloop_26)"
            />
            <path
              className="prefix__cls-9"
              d="M166.48 130.47l-.37.34z"
            />
            <path
              d="M206 357.31s-4.28-88.82 25.78-178l-1.52 1.36c-21.34 19.51-34.63 48.19-34.63 48.19-14-30.28-27.27-85.57-30-97.56a507.5 507.5 0 00-45 46.66s12.67 99.14 29.4 126.26c-.03-.03 30.97 38.91 55.97 53.09z"
              fill="url(#prefix__Naamloos_verloop_12-3)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
